import { Damage } from '@/types';
import {
  isChangedDamageLine,
  isRemovedDamageLine,
} from './damageLinePresentation';

export const getColorForAuthorizationStatus = (data: Damage) => {
  const { isNew } = data;
  if (isRemovedDamageLine(data)) return 'row-deleted';
  if (isChangedDamageLine(data)) return 'row-changed';
  if (isNew) return 'row-new';
  return '';
};
